import { useSelector as useSelectorOriginal } from 'react-redux'
import { AppState } from '../types'

export const useSelector: <TSelected = unknown>(
  selector: (state: AppState) => TSelected,
  equalityFn?: ((left: TSelected, right: TSelected) => boolean) | undefined
) => TSelected = useSelectorOriginal

// export const useDispatch: <Action extends AppAction>() => ThunkDispatch<AppState, unknown, Action> = useDispatchOriginal
